<template>
  <BreadCrumb PageTitle="Sellers List" />
  <SellersList />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import SellersList from "../../template-components/Ecommerce/SellersList/SellersList.vue";

export default defineComponent({
  name: "SellersListPage",
  components: {
    BreadCrumb,
    SellersList,
  },
});
</script>